import Vue from "vue";
import Vuex from "vuex";
import userAgent from "./modules/userAgent";
import animationsData from "./animationsData";
import axios from "axios";

const API_URL = "//api.prihcs.com/polls/alk_odactra_pj";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isiStatus: false,
    isiCssTransitionStatus: false,
    UnsupportedDevice: false,
    lastPushedSection: 0,
    scrollPositions: {
      susan: 0,
      joseph: 0,
      gabrielle: 0,
    },
    currentSection: {
      id: null,
      section: null,
      progress: null,
      total: null,
      percentage: null,
    },
    isMenuActive: false,
    isAdditionalActive: false,
    currentPage: {
      isHomePage: false,
      isSusan: false,
      isJoseph: false,
      isGabrielle: false,
    },
    routes: [
      {
        name: "Susan",
        to: "/patients/susan/",
        active: true,
        description:
          "Clinical case presentation by Dr. Priya Bansal, MD; an allergist/immunologist at Asthma and Allergy Wellness Center in St. Charles, Illinois.",
        image: require("@/assets/img/homepage/susan.png"),
        doctor: require("@/assets/img/homepage/patient_health-1.png"),
        kol: require("@/assets/img/homepage/patient_kol-1.png"),
        sideNav: require("@/assets/img/sidenav/sidenav_susan.png"),
      },
      {
        name: "Joseph",
        to: "/patients/joseph/",
        active: false,
        description:
          "Clinical case presentation by Dr. Payel Gupta; an allergist and immunologist at ENT and Allergy Associated New York City, New York",
        image: require("@/assets/img/homepage/joseph.png"),
        doctor: require("@/assets/img/homepage/patient_health-2.png"),
        kol: require("@/assets/img/homepage/patient_kol-2.png"),
        sideNav: require("@/assets/img/sidenav/sidenav_joseph.png"),
      },
      {
        name: "Gabrielle",
        to: "/patients/gabrielle/",
        active: true,
        description:
          "Clinical case presentation by Shant Korkigian; an otolaryngologist, head and neck surgeon at ENT specialists, PC Novi Michigan.",
        image: require("@/assets/img/homepage/gabrielle.png"),
        doctor: require("@/assets/img/homepage/patient_health-3.png"),
        kol: require("@/assets/img/homepage/patient_kol-3.png"),
        sideNav: require("@/assets/img/sidenav/sidenav_gabrielle.png"),
      },
    ],
    urls: {
      PP: "https://haymarketmediaus.com/haymarket-media-medical-privacy-policy/", // Privacy Policy
      TC: "https://haymarketmediaus.com/haymarket-media-inc-us-terms-conditions/", // Terms of Conditions,
      PI: "https://www.odactra.com/assets/pdf/odactra-full-pi.pdf", // Prescribing Information
      HCP: "https://www.odactrahcp.com/", // LIVE SITE HCP,
      HCP_INFO: "https://www.odactrahcp.com/request-samples-and-info",
      ALK: "https://www.alksavings.com/#/app/layout/home",
      LRNMORE: "https://www.empr.com/custom/patient-journeys/odactra/",
      MG: "https://www.odactra.com/assets/pdf/odactra-medication-guide.pdf", // Medication Guide,
      DAG: "#", //
      none: "#",
    },
    patients: {
      susan: {
        id: 0,
        name: "Susan",
        slug: "susan",
        to: "/patients/susan/",
        image: require("@/assets/img/patients/susan/susan_0.png"),
        mobileImage: require("@/assets/img/homepage/susan.png"),
        description:
          "is unable to maintain subcutaneous immunotherapy due to a busy schedule",
        story:
          "A 36-year-old working mother of <nobr>3 children</nobr> who is unable to continue subcutaneous immunotherapy (SCIT) due to a busy schedule",
        footnotes:
          'Patient case based on physician<br class="no-large-device"/> experience. Not actual patient.',
        references: false,
        quoteImage: require("@/assets/img/quote/quote_susan.png"),
        docImage: require("@/assets/img/homepage/patient_health-1.png"),
        docDesc:
          "<b>Dr. Priya Bansal</b>, summarizes content presented on this webpage, with a primary focus on this patient. <nobr>Dr. Bansal</nobr> is a paid consultant of ALK",
        HomeDesc:
          "Clinical case presentation by<br/> <b>Dr. Priya Bansal</b>; <nobr> an allergist and immunologist in </nobr><br/> St. Charles, Illinois<br/> <nobr>Dr. Bansal</nobr> is a paid consultant of ALK",
        infoBlocks: {
          1: [
            {
              id: 1,
              text: '"My days are busy with work and my children’s activities. I would like a medication that provides symptom relief and doesn’t require frequent visits to a medical professional’s office."',
            },
          ],
          2: [
            {
              id: 2,
              text: '"I am fed up with my year-round allergy symptoms and I am looking for further relief."',
            },
          ],
          3: [
            {
              id: 3,
              text: '"I prefer a treatment that I can take at home. Is there an oral treatment option available for me to treat my HDM-mediated allergic rhinitis?"',
            },
          ],
          4: [
            {
              id: 4,
              text: '"In addition to HDMs, I have sensitivity to other allergens, including trees and grasses. Will I still be a good candidate for ODACTRA<sup>®</sup>?"',
            },
          ],
          5: [
            {
              id: 5,
              text: '"How do I start my patients on ODACTRA<sup>®</sup>?"',
            },
          ],
          6: [
            {
              id: 6,
              text: '"ALK’s support program helped me initiate ODACTRA<sup>®</sup> and made it affordable for me."',
            },
          ],
          7: [
            {
              id: 7,
              text: '"I’m glad to have a treatment that provided significant allergy relief, and that I was able to take while continuing with my busy days."',
            },
          ],
        },
      },
      joseph: {
        id: 1,
        name: "Joseph",
        slug: "joseph",
        to: "/patients/joseph/",
        image: require("@/assets/img/patients/joseph/joseph_0.png"),
        mobileImage: require("@/assets/img/homepage/joseph.png"),
        description:
          "has recurring cold-like symptoms, which worsen during fall and winter",
        story:
          "A 41-year-old regional sales representative with recurring cold-like symptoms, which worsen during fall and winter.",
        footnotes:
          'Patient case based on physician<br class="no-large-device"/> experience. Not actual patient.',
        references: false,
        quoteImage: require("@/assets/img/quote/quote_joseph.png"),
        docImage: require("@/assets/img/homepage/patient_health-2.png"),
        docDesc:
          "<b>Dr. Payel Gupta, MD</b>, summarizes content presented on this webpage, with a primary focus on this patient. <nobr>Dr. Gupta</nobr> is a paid consultant of ALK",
        HomeDesc:
          "Clinical case presentation by<br/> <b>Dr. Payel Gupta</b>; <nobr> an allergist </nobr> and immunologist in <nobr>New York City, New York</nobr> <br> <nobr>Dr. Gupta</nobr> is a paid <nobr>consultant of ALK</nobr>",
        infoBlocks: {
          1: [
            {
              id: 1,
              text: '"I\'m tired of having to take so many medications that are not providing enough relief to manage my demanding work schedule."',
            },
          ],
          2: [
            {
              id: 2,
              text: '"I find my allergies are less disruptive and I can manage my work days with less discomfort."',
            },
          ],
          3: [
            {
              id: 3,
              text: '"I’m grateful for ALK’s support program. My therapy is effective and affordable, thanks to my allergy tablet savings card."',
            },
          ],
        },
      },
      gabrielle: {
        id: 2,
        name: "Gabrielle",
        slug: "gabrielle",
        to: "/patients/gabrielle/",
        image: require("@/assets/img/patients/gabrielle/gabrielle_2.png"),
        mobileImage: require("@/assets/img/homepage/gabrielle.png"),
        description:
          "has seasonal pollen exacerbations with an underlying perennial factor",
        story:
          "40-year-old female with seasonal pollen exacerbations with an underlying perennial factor.",
        footnotes:
          'Patient case based on physician<br class="no-large-device"/> experience. Not actual patient.',
        references: false,
        quoteImage: require("@/assets/img/quote/quote_gabrielle.png"),
        docImage: require("@/assets/img/homepage/patient_health-3.png"),
        docDesc:
          "<b>Dr. Shant Korkigian, MD</b>, summarizes content presented on this webpage, with a primary focus on this patient. <nobr>Dr. Korkigian</nobr> is a paid <nobr>consultant of ALK</nobr>",
        HomeDesc:
          "Clinical case presentation by<br/> <b>Dr. Shant Korkigian</b>; an otolaryngologist,<br/> head and neck surgeon in <nobr> Novi, Michigan </nobr><br/> Dr. Korkigian is a paid <nobr>consultant of ALK</nobr>",
        infoBlocks: {
          1: [
            {
              id: 1,
              text: '"My symptoms are year-round and get much worse during the height of pollen season."',
            },
          ],
          2: [
            {
              id: 2,
              text: '"Despite taking so many medications, I am still having unbearable allergy symptoms."',
            },
          ],
          3: [
            {
              id: 3,
              text: '"My symptoms are unbearable and I need a treatment option that provides relief faster than <nobr>6 months</nobr> to a year."',
            },
          ],
          4: [
            {
              id: 4,
              text: '"I find myself with less discomfort and I am less bothered by allergy symptoms when I go to sleep."',
            },
          ],
          5: [
            {
              id: 5,
              text: '"I’m grateful for ALK’s support program. My therapy is effective and affordable, thanks to my allergy tablet savings card."',
            },
          ],
        },
      },
    },
    quizData: {
      patients: {
        susan: {
          id: 1,
          name: "susan",
          question: {
            1: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: "Fewer than 50%",
              subtitle: "Clinical Consideration Question 1",
              title:
                "What percentage of patients who initiate SCIT complete a <nobr>3-year</nobr> course?",
              multi: false,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Fewer than 10%",
                  value: "Fewer than 10%",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Fewer than 30%",
                  value: "Fewer than 30%",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Fewer than 50%",
                  value: "Fewer than 50%",
                },
              ],
            },
            2: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: [
                "Patient lifestyle/ability to adhere to therapy",
                "Allergen profile",
                "Patient treatment goals (speed of onset/medications/symptoms)",
                "Existence of perennial or seasonal allergy symptoms",
              ],
              subtitle: "Clinical Consideration Question 2",
              title:
                "What are some important patient selection criteria to consider when choosing treatment?",
              multi: true,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Patient lifestyle/ability to adhere to therapy",
                  value: "Patient lifestyle/ability to adhere to therapy",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Allergen profile",
                  value: "Allergen profile",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Patient treatment goals <nobr>(speed of</nobr> onset/medications/symptoms)",
                  value:
                    "Patient treatment goals (speed of onset/medications/symptoms)",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "Existence of perennial or seasonal allergy symptoms",
                  value: "Existence of perennial or seasonal allergy symptoms",
                },
              ],
            },
            3: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: [
                "Stop SCIT",
                "Start sublingual immunotherapy tablet",
                "Modify symptomatic medications",
              ],
              subtitle: "Clinical CONSIDERATIONS Question 3",
              title:
                "What would you recommend as the next step in Susan’s treatment based on her busy lifestyle?",
              multi: true,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Stop SCIT",
                  value: "Stop SCIT",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Start sublingual immunotherapy tablet",
                  value: "Start sublingual immunotherapy tablet",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Modify symptomatic medications",
                  value: "Modify symptomatic medications",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "Continue SCIT",
                  value: "Continue SCIT",
                },
              ],
            },
            4: {
              answered: false,
              subtitle: "Clinical CONSIDERATIONS Question 4",
              title:
                "What are the medical benefits or considerations for prescribing ODACTRA<sup>®</sup>?",
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: [
                "Reduction in symptoms and allergy rescue medication use when added to traditional pharmacotherapy",
                "Requires in-office administration of first dose to observe for systemic adverse reactions",
                "Onset of action in 8 to 14 weeks",
                "Proven efficacy in mono- and polysensitized patients throughout the year",
              ],
              multi: true,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Reduction in symptoms and allergy rescue medication use when added to traditional pharmacotherapy",
                  value:
                    "Reduction in symptoms and allergy rescue medication use when added to traditional pharmacotherapy",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Requires in-office administration of first dose to observe for systemic adverse reactions",
                  value:
                    "Requires in-office administration of first dose to observe for systemic adverse reactions",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Onset of action in 8 to 14 weeks",
                  value: "Onset of action in 8 to 14 weeks",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "Proven efficacy in mono- and polysensitized patients throughout the year",
                  value:
                    "Proven efficacy in mono- and polysensitized patients throughout the year",
                },
              ],
            },
            5: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: "true",
              subtitle: "Clinical CONSIDERATIONS Question 5",
              title:
                "True or False, ALK offers a support program to help patients, including individuals like Susan with a high-deductible plan to initiate ODACTRA<sup>®</sup>",
              multi: false,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "True",
                  value: "true",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "False",
                  value: "false",
                },
              ],
            },
          },
        },
        joseph: {
          id: 2,
          name: "joseph",
          question: {
            1: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: "Fewer than 50%",
              subtitle: "Clinical Consideration Question 1",
              title:
                "What percentage of your patients suffered from year-round symptoms, such as recurring upper respiratory tract infections and cold-like symptoms, for many years due to perennial allergens before receiving appropriate therapy?",
              multi: false,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Fewer than 10%",
                  value: "Fewer than 10%",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Fewer than 50%",
                  value: "Fewer than 50%",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Greater than 50%",
                  value: "Greater than 50%",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "Greater than 75%",
                  value: "Greater than 75%",
                },
              ],
            },
            2: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: ["Grass", "Cat", "Dog", "Tree"],
              subtitle: "Clinical Consideration Question 2",
              title:
                "Polysensitized patients with moderate to severe HDM-induced AR commonly have sensitivities to which additional allergens?",
              multi: true,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Grass",
                  value: "Grass",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Cat",
                  value: "Cat",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Dog",
                  value: "Dog",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "Tree",
                  value: "Tree",
                },
              ],
            },
            3: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: [
                "Patient lifestyle",
                "Convenience of administration",
                "Desire to reduce allergy symptoms and use of symptomatic medications",
                "Patient support program available to assist your patients",
                "Mild to moderate adverse events",
              ],
              subtitle: "Clinical Consideration Question 3",
              title:
                "At this point in Joseph’s journey, which factors would influence your decision to recommend SLIT-tablet?",
              multi: true,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Patient lifestyle",
                  value: "Patient lifestyle",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Convenience of administration",
                  value: "Convenience of administration",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Desire to reduce allergy symptoms and use of symptomatic medications",
                  value:
                    "Desire to reduce allergy symptoms and use of symptomatic medications",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "Patient support program available to assist your patients",
                  value:
                    "Patient support program available to assist your patients",
                },
                {
                  order: 5,
                  letter: "e",
                  text: "Mild to moderate adverse events",
                  value: "Mild to moderate adverse events",
                },
              ],
            },
            4: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: "Yes",
              subtitle: "Clinical Consideration Question 4",
              title:
                "Do your patients with HDM-induced AR experience a similar rate of improvement with <nobr>SLIT-tablets?</nobr>",
              multi: false,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Yes",
                  value: "Yes",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "No",
                  value: "No",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Other (eg, patients are not on <nobr>SLIT-tablets)</nobr>",
                  value: "Other (eg, patients are not on SLIT-tablets)",
                },
              ],
            },
            5: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: [
                "Monosensitized and polysensitized patients",
                "Patients who are looking for low out-of-pocket cost",
                "Patients with a positive skin prick test for HDMs",
                "Patients who travel extensively",
              ],
              subtitle: "Clinical Consideration Question 5",
              title:
                "Based on this case study, what type of patients would ODACTRA<sup>®</sup> be most suitable for?",
              multi: true,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Monosensitized and polysensitized patients",
                  value: "Monosensitized and polysensitized patients",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Patients who are looking for low out-of-pocket cost",
                  value: "Patients who are looking for low out-of-pocket cost",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Patients with a positive skin prick test for HDMs",
                  value: "Patients with a positive skin prick test for HDMs",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "Patients who travel extensively",
                  value: "Patients who travel extensively",
                },
              ],
            },
          },
        },
        gabrielle: {
          id: 3,
          name: "gabrielle",
          question: {
            1: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: "Fewer than 50%",
              subtitle: "Clinical Consideration Question 1",
              title:
                "What percentage of your AR patients have suffered for 2 or more years while on inadequate symptomatic medications prior to seeing an allergy specialist?",
              multi: false,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Fewer than 10%",
                  value: "Fewer than 10%",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Fewer than 50%",
                  value: "Fewer than 50%",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Greater than 50%",
                  value: "Greater than 50%",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "Greater than 75%",
                  value: "Greater than 75%",
                },
              ],
            },
            2: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: "8-14 weeks",
              subtitle: "Clinical Consideration Question 2",
              title:
                "How soon can your patients see results with ODACTRA<sup>®</sup>?",
              multi: false,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "52 weeks",
                  value: "52 weeks",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "24 weeks",
                  value: "24 weeks",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "16 weeks",
                  value: "16 weeks",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "8-14 weeks",
                  value: "8-14 weeks",
                },
              ],
            },
            3: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: "True",
              subtitle: "Clinical Consideration Question 3",
              title:
                "Despite having sensitivity to multiple allergens, HDMs seem to be the prominent cause of Gabrielle’s year-round symptoms.<br/><br/>True or False? Treating HDM allergy has been shown to help reduce symptoms and medication use throughout the year, including pollen seasons.",
              multi: false,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "True",
                  value: "True",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "False",
                  value: "False",
                },
              ],
            },
            4: {
              answered: false,
              lastAnswer: "",
              finalAnswer: false,
              correctAnswer: [
                "Proven efficacy in mono- and poly-sensitized patients",
                "Reduction in symptoms and allergy rescue medication use when added to traditional pharmacotherapy",
                "Treats the underlying cause of allergy and not simply the symptoms",
                "Onset of action in 8 to 14 weeks",
                "Requires in-office administration of first dose to observe for systemic adverse reactions",
              ],
              subtitle: "Clinical Consideration Question 4",
              title:
                "What are the clinical benefits or considerations for prescribing ODACTRA<sup>®</sup>?",
              multi: true,
              buttons: [
                {
                  order: 1,
                  letter: "a",
                  text: "Proven efficacy in mono- and poly-sensitized patients",
                  value:
                    "Proven efficacy in mono- and poly-sensitized patients",
                },
                {
                  order: 2,
                  letter: "b",
                  text: "Reduction in symptoms and allergy rescue medication use when added to traditional pharmacotherapy",
                  value:
                    "Reduction in symptoms and allergy rescue medication use when added to traditional pharmacotherapy",
                },
                {
                  order: 3,
                  letter: "c",
                  text: "Treats the underlying cause of allergy and not simply the symptoms",
                  value:
                    "Treats the underlying cause of allergy and not simply the symptoms",
                },
                {
                  order: 4,
                  letter: "d",
                  text: "Onset of action in 8 to 14 weeks",
                  value: "Onset of action in 8 to 14 weeks",
                },
                {
                  order: 5,
                  letter: "e",
                  text: "Requires in-office administration of first dose to observe for systemic adverse reactions",
                  value:
                    "Requires in-office administration of first dose to observe for systemic adverse reactions",
                },
              ],
            },
          },
        },
      },
    },
    quizProgress: 1,
    poll_info: {
      susan: {
        3: {
          a: 1,
          b: 1,
          c: 1,
          d: 1,
        },
      },
      joseph: {
        1: {
          a: 1,
          b: 1,
          c: 1,
          d: 1,
        },
        3: {
          a: 1,
          b: 1,
          c: 1,
          d: 1,
          e: 1,
        },
        4: {
          a: 1,
          b: 1,
          c: 1,
        },
      },
      gabrielle: {
        1: {
          a: 1,
          b: 1,
          c: 1,
          d: 1,
          e: 1,
        },
      },
    },
    tabDataSusan: {
      1: [
        {
          title: "Reduction in TNSS",
          boxTitle: "WEEK 8<br/>(SECONDARY END POINT)<sup>11,12</sup>",
          boxPercent: '20.4<span class="percent">%</span>',
          boxText: "REDUCTION<br/>IN TNSS*",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 5.34 (n=40)<br/>Placebo: 6.71 (n=39)<br/>95% Cl: –33.3%, –6.8%<br/>(<i class="mr-1">P</i><.05)',
        },
        {
          title: "Reduction in TNSS",
          boxTitle: "WEEK 24<br/>(PRIMARY END POINT)<sup>11,12</sup>",
          boxPercent: '48.6<span class="percent">%</span>',
          boxText: "REDUCTION<br/>IN TNSS",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 3.83 (n=36)<br/>Placebo: 7.45 (n=34)<br/>95% Cl: –60.2%, –35.3%<br/>(<i class="mr-1">P</i><.05)',
          bigger: true,
        },
      ],
      2: [
        {
          title: "Reduction in TOSS",
          boxTitle: "WEEK 24<sup>11</sup>",
          boxPercent: '67.9<span class="percent">%</span>',
          boxText: "REDUCTION<br/>IN TOSS",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 0.61 (n=40)<br/>Placebo: 1.87 (n=40)<br/>95% Cl: –87.4%, –41.2%<br/>(<i class="mr-1">P</i><.001)',
        },
      ],
    },
    tabDataJoseph: {
      1: [
        {
          title: "Reduction in TNSS",
          boxTitle: "WEEK 8<br/>(SECONDARY END POINT)<sup>5,8</sup>",
          boxPercent: '20.4<span class="percent">%</span>',
          boxText: "REDUCTION<br/>IN TNSS*",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 5.34 (n=40)<br/>Placebo: 6.71 (n=39)<br/>95% Cl: –33.3%, –6.8%<br/>(<i class="mr-1">P</i><.05)',
        },
        {
          title: "Reduction in TNSS",
          boxTitle: "WEEK 24<br/>(PRIMARY END POINT)<sup>5,8</sup>",
          boxPercent: '48.6<span class="percent">%</span>',
          boxText: "REDUCTION<br/>IN TNSS",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 3.83 (n=36)<br/>Placebo: 7.45 (n=34)<br/>95% Cl: –60.2%, –35.3%<br/>(<i class="mr-1">P</i><.05)',
          bigger: true,
        },
      ],
      2: [
        {
          title: "Reduction in TOSS",
          boxTitle: "WEEK 24<sup>5</sup>",
          boxPercent: '67.9<span class="percent">%</span>',
          boxText: "REDUCTION<br/>IN TOSS",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 0.61 (n=40)<br/>Placebo: 1.87 (n=40)<br/>95% Cl: –87.4%, –41.2%<br/>(<i class="mr-1">P</i><.001)',
          biggest: true,
          haveBR: true,
        },
      ],
    },
    tabDataGabrielle: {
      1: [
        {
          title: "Reduction in TNSS",
          boxTitle: "WEEK 8<br/>(SECONDARY END POINT)<sup>6,7</sup>",
          boxPercent: '20.4<span class="percent">%</span>',
          boxText: "REDUCTION<br/>IN TNSS*",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 5.34 (n=40)<br/>Placebo: 6.71 (n=39)<br/>95% Cl: –33.3%, –6.8%<br/>(<i class="mr-1">P</i><.05)',
        },
        {
          title: "Reduction in TNSS",
          boxTitle: "WEEK 24<br/>(PRIMARY END POINT)<sup>6,7</sup>",
          boxPercent: '48.6<span class="percent">%</span>',
          boxText: "REDUCTION<br/>IN TNSS",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 3.83 (n=36)<br/>Placebo: 7.45 (n=34)<br/>95% Cl: –60.2%, –35.3%<br/>(<i class="mr-1">P</i><.05)',
          bigger: true,
        },
      ],
      2: [
        {
          title: "Reduction in TOSS",
          boxTitle: "WEEK 24<sup>6</sup>",
          boxPercent: '67.9<span class="percent">%</span>',
          boxText: "REDUCTION<br/>IN TOSS",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 0.61 (n=40)<br/>Placebo: 1.87 (n=40)<br/>95% Cl: –87.4%, –41.2%<br/>(<i class="mr-1">P</i><.001)',
        },
      ],
      3: [
        {
          title: "Reduction in TCRS",
          boxTitle: "PRIMARY END POINT",
          boxPercent: '17.2<span class="percent">%</span>',
          boxText:
            "REDUCTION IN TCRS<br/>VS SYMPTOMATIC<br/>MEDICATIONS<br/>ALONE<sup>7,*</sup>",
          boxFootnotes:
            'ODACTRA<sup>®</sup>: 4.10 (n=566)<br/>Placebo: 4.95 (n=620)<br/>95% Cl: –25.0%, –9.7%<br/>(<i class="mr-1">P</i><.001)',
        },
      ],
    },
    controllerExist: false,
    controllerProgressExist: false,
    isiHeight: 0,
    isiState: null,
    videoState: false,
    timeProgress: 0,
    isLockScroll: false,
    animationsData,
  },
  modules: {
    userAgent,
  },
  mutations: {
    UPDATE_LOCK_STATE(state, value) {
      state.isScrollLock = value;
    },
    TOGGLE_MENU_STATUS(state, value) {
      state.isMenuActive = value;
    },
    TOGGLE_ADDITIONAL_STATUS(state, value) {
      state.isAdditionalActive = value;
    },
    TOGGLE_ISI_STATUS(state, value) {
      const timeout = state.isiStatus ? 100 : 0;
      setTimeout(() => {
        state.isiStatus = value;
      }, timeout)
    },
    TOGGLE_CSS_ISI_STATUS(state, value) {
      const timeout = state.isiCssTransitionStatus ? 0 : 1100;
      setTimeout(() => {
        state.isiCssTransitionStatus = value;
      }, timeout)
    },
    TOGGLE_UNSUPPORTED_DEVICE(state, value) {
      state.UnsupportedDevice = value;
    },
    SET_SECTION_FULL_SCROLL(state, value) {
      state.currentSection.percentage[value] = 100.0;
    },
    SET_CURRENT_SECTION(state, value) {
      state.currentSection.id = value.id;
      state.currentSection.section = value.section;
      state.currentSection.progress = value.progress;
      state.currentSection.total = value.total;
      state.currentSection.percentage = {
        ...state.currentSection.percentage,
        [value.section]: value.percentage,
      };
    },
    SET_POLL_DATA(state, data) {
      state.poll_info = data;
      for (var key in data) {
        for (var key2 in data[key]) {
          var total = 0;
          for (var key3 in data[key][key2]) {
            total = total + data[key][key2][key3];
            state.poll_info[key][key2]["sum"] = total;
          }
        }
      }
    },
    SET_SCROLL_CONTROLLER_STATE(state, value) {
      state.controllerExist = value;
    },
    SET_SCROLL_PROGRESS_CONTROLLER_STATE(state, value) {
      state.controllerProgressExist = value;
    },
    SET_ISI_STATE(state, value) {
      state.isiState = value;
    },
    SET_ISI_HEIGHT(state, value) {
      state.isiHeight = value;
    },
    SET_ACTIVE_ROUTE(state, value) {
      state.routes[value].active = true;
    },
    SET_INACTIVE_ROUTE(state, value) {
      state.routes[value].active = false;
    },
    SET_PAGE_INFO(state, value) {
      state.currentPage.isHomePage = value.isHomePage;
      state.currentPage.isSusan = value.isSusan;
      state.currentPage.isJoseph = value.isJoseph;
      state.currentPage.isGabrielle = value.isGabrielle;
    },
    TOGGLE_VIDEO(state, value) {
      state.videoState = value;
      console.log("Play video");
    },
    SET_VIDEO_PROGRESS(state, value) {
      state.timeProgress = value;
    },
    // SET_SECTION_PROGRESS(state, sectionObj) {
    //   state.sectionsProgress = {
    //     ...state.sectionsProgress,
    //     [sectionObj.section]: sectionObj.progress
    //   };
    // },
    // RESET_SECTION_PROGRESS(state, sectionObj) {
    //   state.sectionsProgress = {};
    // },
    LAST_PUSHED_SECTION(state, id) {
      state.lastPushedSection = id;
    },
    SET_QUIZ_PROGRESS(state, number) {
      state.quizProgress = number;
    },
    UPDATE_ANSWER_STATE(state, value) {
      if (value.answer !== "skip" && value.answer !== "submit") {
        if (!value.multiple) {
          state.quizData.patients[value.page].question[
            value.question
          ].answered = true;
        }
        state.quizData.patients[value.page].question[
          value.question
        ].lastAnswer = value.answer;
        state.quizData.patients[value.page].question[
          value.question
        ].finalAnswer = value.finalAnswer;
      } else if (value.answer === "skip") {
        state.quizData.patients[value.page].question[
          value.question
        ].answered = true;
        state.quizData.patients[value.page].question[
          value.question
        ].lastAnswer = value.answer;
        if (value.multiple) {
          state.quizData.patients[value.page].question[
            value.question
          ].lastAnswer = value.answerValues;
        }
      } else if (value.answer === "submit") {
        state.quizData.patients[value.page].question[
          value.question
        ].answered = true;
        state.quizData.patients[value.page].question[
          value.question
        ].lastAnswer = value.answerValues;
      }
      localStorage.setItem(
        "quizData_alk_odactra_pj",
        JSON.stringify(state.quizData)
      );
    },
    UPDATE_QUIZ_DATA(state, value) {
      state.quizData = value;
      localStorage.setItem(
        "quizData_alk_odactra_pj",
        JSON.stringify(state.quizData)
      );
    },
    SET_PATIENTS_SCROLL_SUSAN(state, value) {
      state.scrollPositions.susan = value;
    },
    SET_PATIENTS_SCROLL_JOSEPH(state, value) {
      state.scrollPositions.joseph = value;
    },
    SET_PATIENTS_SCROLL_GABRIELLE(state, value) {
      state.scrollPositions.gabrielle = value;
    },
  },
  actions: {
    sendAnswer({ commit }, data) {
      return axios({
        method: "post",
        url: `${API_URL}/${data.patient}/${data.id}/`,
        data: data.answers,
      })
        .then(function (response) {
          // console.log('response after request ', response.data[0]);
          commit("SET_POLL_DATA", response.data[0]);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async setInitialAnswer({ commit }) {
      await axios
        .post(`${API_URL}`)
        .then(function (response) {
          commit("SET_POLL_DATA", response.data[0]);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
});
